<template lang="pug">
.vprStartworkPlayerResultsComponent
  vpr-player-background( :subject="subject" )
  ui-loader( v-if="isLoading" )
  template( v-else )
    .vprContent
      iframe(
        :src="vpr.startwork.iframeUrl + '?auto_load=false'"
        loading="lazy"
        ref="iframeRef"
      )
</template>

<script>
import { computed, inject, onUnmounted, ref, watch } from '@vue/runtime-core'
import VprPlayerBackground from '../VprPlayerBackground'
import PlayerModalClose from '@/components/Player/PlayerModalClose/PlayerModalClose'
import PlayerVprController from '@/controllers/ChildVpr/PlayerVprController'
import router from '@/router'

export default {
  components: {
    VprPlayerBackground,
    PlayerModalClose
  },
  setup () {
    const store = inject('store')
    const controller = inject('controller')
    controller.childVprStateRequest()

    const iframeRef = ref(null)

    const { initIframeListener, destroyIframeListener, $on, $off } = PlayerVprController(controller)

    watch(controller.isVprStateLoading, () => {
      setTimeout(() => { initIframeListener(iframeRef.value) }, 0)
    })

    const showCloseModal = () => {
      store.modalQueue.push({
        key: 'vprclose',
        component: PlayerModalClose,
        params: {
          isClosable: false
        },
        props: {
          title: 'Выйти из просмотра результатов ВПР?'
        },
        on: {
          submit: onCloseSubmit
        }
      })
    }
    const onCloseSubmit = () => router.push({ name: 'VprContents' })

    $on('iframe-close-click', showCloseModal)

    onUnmounted(() => {
      destroyIframeListener()
      $off('iframe-close-click', showCloseModal)
    })

    return {
      iframeRef,
      vpr: computed(() => controller.childVpr.value.userItem.vpr),
      subject: computed(() => controller.childVpr.value.userItem.vpr.subject),
      isLoading: computed(() => controller.isVprStateLoading.value)
    }
  }
}
</script>

<style lang="sass" scoped>
.vprStartworkPlayerResultsComponent
  position: fixed
  width: 100vw
  height: 100%
  top: 0
  left: 0
  background-color: $cBackground
  z-index: $zIndexPlayerIframe
  display: flex
  align-items: center
  justify-content: center

  > .vprContent
    width: 100%
    height: 100%
    max-width: 1100px
    max-height: 700px
    border-radius: $brXXL
    background-color: $cWhite
    padding: 5*$u

    > iframe
      width: 100%
      height: 100%
</style>
